<template>
  <div class="cadastro-usuario">
    <v-container
      fluid
    >
      <h1 class="titulo">Afiliados</h1>

      <div class="box-table">
        <expansionPanelDefault :handleClick="montarLabelFiltro">
          <v-row class="justify-end">
            <v-col cols="12" md="2">
              <v-text-field
                append-icon="search"
                :label="'CPF'"
                single-line
                hide-details
                v-on:keyup.enter="buscarPorEntidade"
                v-model="textSearch"
                v-mask="['###.###.###-##']"
                color="primary"
                solo
                dense
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-select
                v-model="tipoStatus"
                :items="tiposStatus"
                label="Selecionar estado"
                dense
                item-text="text"
                item-value="value"
                hide-details
                solo
                class="select-status"
              >
              </v-select>
            </v-col>
            
            <v-col cols="12" md="2">
              <FiltroRangeDate
                class="mr-3 range-date"
                @input="filtrar"
                :value="rangeDate"
                :labelBtn="'Selecionar Data'"
                :actionLabels="{ apply: 'OK' }"
                style="width: 100%;"
                :disableBtnClear="false"
              />
            </v-col>
          </v-row>
        </expansionPanelDefault>

        <v-skeleton-loader
          :loading="loadingTable"
          :transition="'fade-transition'"
          height="500"
          type="table">
          <v-data-table
            :headers="headers"
            :search="search"
            :items="listaItens"
            width="300px"
            flat
            hide-default-footer
            :loading="loadingPag"
            :items-per-page.sync="itemsPerPage"> 

            <template v-slot:item.action="{ item }">
              <v-btn
                small
                @click="openModalDadosUsuarios(item)"
                tile
                outlined 
                :color="variables.colorPrimary"
                class="mr-2 btn-frame"
                :disabled="loadingPag"
              >
                Avaliar
              </v-btn>

              <v-btn
                small
                @click="openModalAprovarAfiliado(item)"
                tile
                outlined 
                class="mr-2 btn-frame"
                :color="variables.colorSecondary"
                :disabled="loadingPag"
              >
                {{ item.jsonFlags.pendingApprovalAffiliate ? 'Aprovar' : 'Ver contratos' }}
              </v-btn>

              <v-btn
                small
                @click="handlerDesativarAfiliado(item)"
                tile
                outlined 
                class="btn-frame"
                :color="variables.colorError"
                :disabled="loadingPag"
              >
              {{ item.jsonFlags.pendingApprovalAffiliate ? 'Reprovar' : 'Desabilitar' }}
              </v-btn>
            </template>
             
            <template v-slot:item.affiliate.contracts="{ item }">
              {{ item.affiliate.contracts.length }}
            </template>


            <template v-slot:footer>
              <div class="wrapper-footer">
                <div class="qtd-paginacao">
                  {{ pageStart }}
                  -
                  {{ pageStop }}
                  de
                  {{ totalItens }}
                </div>
                <v-pagination
                  v-model="page"
                  :length="numberOfPages"
                  circle
                  :disabled="disabled"
                  :total-visible="7"
                  class="box-table-paginacao"
                  v-if="numberOfPages > 1"></v-pagination>
              </div>
            </template>
          </v-data-table>
        </v-skeleton-loader>
      </div>

      <v-btn class="mx-2 fab-cadastrar-usuario" fab color="primary" @click="cadastrar">
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </v-container>

    <ModalDadosUsuario />
    <ModalAprovarAfiliados
      :key="afiliado.id"
      :afiliado="afiliado"
      @atualizarListagem="getData()"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// eslint-disable-next-line no-unused-vars
import Events from '@/core/service/events'
// eslint-disable-next-line no-unused-vars
import { errorSnackbar, successSnackbar } from '@/core/service/utils'
import moment from 'moment'
import { mask } from 'vue-the-mask'

/**
 * MIXIN
 */
import listagemTables from '@/views/mixins/listagemTables'

export default {
  name: 'AfiliadosPendentes',
  components: {
    // BrToolBar: () => import('./components/toolbar'),
    ModalDadosUsuario: () => import('@/views/components/modalDadosUsuario'),
    FiltroRangeDate: () => import('@/views/components/filtroRangeDate'),
    expansionPanelDefault: () => import('@/views/components/expansionPanelDefault'),
    ModalAprovarAfiliados: () => import('./components/modalAprovarAfiliados'),
  },
  mixins: [listagemTables],
  directives: {mask},
  data () {
    return {
      typeBusca: 'entities',
      loadingTable: false,
      textSearch: '',
      headers: [
        { align: 'start', class: 'table-header', text: 'Id', value: 'affiliate.id' },
        { align: 'start', class: 'table-header', text: 'Nome', value: 'jsonData.fullName' },
        { align: 'start', class: 'table-header', text: 'Telefone', value: 'jsonData.phone' },
        { align: 'start', class: 'table-header', text: 'Data Nascimento', value: 'jsonData.birth' },
        { align: 'start', class: 'table-header', text: 'Data Solicitação', value: 'affiliate.created' },
        { align: 'start', class: 'table-header', text: 'Qtd Contratos', value: 'affiliate.contracts'},
        { align: 'end', class: 'table-header', text: '', value: 'action', sortable: false },
      ],
      rangeDate: {
        start: null,
        end: null
      },
      loadingPag: false,
      afiliado: {},
      addlFilter: {},
      tipoStatus: '',
      tiposStatus: [
        { text: 'Todos', value: '' },
        { text: 'Pendentes', value: 'p' },
        { text: 'Aprovados', value: 'a' }
      ]
    }
  },

  watch: {
    'tipoStatus' () {
      this.getData()
    }    
  },

  async mounted () {
    this.loadingTable = true
    this.getData()
  },

  computed: {
    ...mapGetters('afiliadosPendentes', ['listaItens', 'totalItens']),
  },

  methods: {
    ...mapActions('afiliadosPendentes', ['obterAfiliados', 'aprovarAfiliado', 'reprovarAfiliado']),

    somar(i) {
      console.log(i)
      return i.affiliate.contracts.length
    },

    init () {},

    paginacao (pag) {
      this.setPage(pag)
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
      this.getData()
    },

    buscarPorEntidade() {
      const textoFitro = this.textSearch.replace(/\D/g, '')
      this.addlFilter[`e:cod_=`] = undefined
      if (textoFitro) {
        this.addlFilter[`e:cod_=`] = textoFitro
      }
      this.getData()
    },


    filtrar (e) {
      this.rangeDate = {
        start: e.start,
        end: e.end
      }

      this.getData()
    },
    getData () {
      this.loadingTable = true
      this.afiliado = { id: 0 }
      this.obterAfiliados({ 
        page: this.page,
        dtStart: this.rangeDate.start, 
        dtEnd: this.rangeDate.end,
        tipoStatus: this.tipoStatus,
        _addlFilter: this.addlFilter,
        pageSize: this.$store.getters.ItensPaginacao,
      })
        // .then(result => {
        //   if (result.data.totalItens < 1) {
        //     errorSnackbar('Não há dados disponíveis')
        //   }
        // })
        .catch(err => {
          console.log(err)
          errorSnackbar(err.error)
        })
        .finally(() => {
          this.loadingTable = false
        })
    },

    openModalDadosUsuarios (e) {
      Events.$emit('cadastro::openModalCadastro', e)
    },

    openModalAprovarAfiliado (e) {
      Events.$emit('cadastro::openModalAprovarAfiliado', e)
    },

    handlerDesativarAfiliado (e) {
      console.log(e)
      const msg = e.jsonFlags.pendingApprovalAffiliate ? 
        `Tem certeza que deseja reprovar o afiliado: ${e.jsonData.fullName}` :
        `Tem certeza que deseja desabilitar o afiliado: ${e.jsonData.fullName}`
      this.$swal({
        icon: 'warning',
        text: msg,
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      }).then((result) => {
        if (result.value) {
          this.loadingPag = true
          this.reprovarAfiliado({ affiliateId: e.affiliate.id })
          .then(() => {
            if (e.jsonFlags.pendingApprovalAffiliate) {
              successSnackbar('Afiliado reprovado com sucesso!')
            } else {
              successSnackbar('Afiliado desativado com sucesso!')
            }
            this.loadingPag = true
            this.getData()
              .finally(() => { this.loadingPag = false })
          })
          .finally(() => {
            this.loadingPag = false
          })
        }
      })



      
    },
    montarLabelFiltro(){     
      Events.$on('autoCompleteEntities::getSearchText', (val)=>{ this.terminalTextSelected = val })
      let labelFiltro = [
      {
          label: 'Data Inicial:',
          value: moment(this.rangeDate.start).format('DD/MM/YYYY')
        },
        {
          label: 'Data Final:',
          value: moment(this.rangeDate.end).format('DD/MM/YYYY')
        },
    ]
      // codBilhete, entity
      return labelFiltro
    },
  }
}
</script>

<style lang="scss">
  @import '../../../assets/styles/components/table';
  .v-data-table thead tr th,
  .v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
    color: $colorPrimary !important;
  }

  .box-table {

    .v-data-table-header-mobile {
      display: none;
    }
  }

  .fab-cadastrar-usuario {
    position: fixed;
    z-index: 1;
    bottom: 25px;
    right: 5px;

    @media (min-width: 599px) {
      display: none !important;
    }
  }
  .box-table .v-btn.btn-filtro-range-date {
    height: 36px !important;
  }
  .btn-frame {
    width: 85px;
  }
</style>
